import { QRCode } from 'react-qrcode-logo';
import { Paper, Typography, Box } from '@mui/material';

 import { getCurrentConfig } from '../../config/config';
 



const QRCodeComponent = ({ selectedOpenhome }) => {
   const config = getCurrentConfig();
  return (
    <Paper elevation={2} sx={{ p: 3, mt: 2 }}>
      <Typography variant="h5" gutterBottom>
        QR Code
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mt: 2,
        }}
      >
        <Box
          sx={{
            width: 200,
            height: 200,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 2,
            mb: 2,
            bgcolor: 'white',
          }}
        >
          <QRCode
            value={`${config.OFIURL}${selectedOpenhome?.propertyopentimeid}`}
            size={200}
            logoImage={`${config.OFILogo}`}
            logoWidth={50}
            logoHeight={50}
            qrStyle="dots"
            eyeRadius={10}
            bgColor="#ffffff"
            fgColor={config.secondaryColor}
            eyeColor={config.primaryColor}
            logoPadding={2}
            logoPaddingStyle="circle"
            logoBackgroundTransparent={true}
          />
        </Box>
      </Box>
    </Paper>
  );
};

export default QRCodeComponent;